import { ContentService } from 'src/app/services/content/content.service';
import { Component, OnInit } from '@angular/core';
import { LanguagesService } from "src/app/services/languagesService/languages.service";
import { GeolocationService } from "src/app/services/geolocation/geolocation.service";
import { Router , ActivatedRoute} from '@angular/router';
import { RemoteConfigService } from 'src/app/services/remote-config/remote-config.service';
import { InAppBrowser } from '@ionic-native/in-app-browser/ngx';
import { UtilsService } from "src/app/services/utils/utils.service";
import { LaunchNavigator, LaunchNavigatorOptions } from '@ionic-native/launch-navigator/ngx';

@Component({
  selector: 'app-geochallenges-form',
  templateUrl: './geochallenges-form.page.html',
  styleUrls: ['./geochallenges-form.page.scss'],
})
export class GeochallengesFormPage implements OnInit {
  objUserPosition: any;
  public id: string;
  public type: string;
  public proximityRadiusInMeters: any;
  challenge: any;

  constructor(public languageService: LanguagesService,
    public router: Router,
    private geolocationService: GeolocationService,
    private route: ActivatedRoute,
    private remoteConfig: RemoteConfigService,
    private iab: InAppBrowser,
    private launchNavigator: LaunchNavigator,
    private contentService: ContentService,
    private utilsService: UtilsService) { 
      this.id = this.route.snapshot.paramMap.get('id');
      this.type = this.route.snapshot.paramMap.get('type');
      console.log("id" , this.id);
      console.log("type", this.type);
      this.utilsService.getCollectionInfo('geochallenges',this.id).subscribe( (data) => {
        this.challenge = data;
      });
      this.remoteConfig.getSettingsGeochallengesConfig().subscribe((data: any) => {
        this.proximityRadiusInMeters = data['radius-challenge'];
      });
    } 

  ngOnInit() {
    // below code to take the updated snapshot of location

    console.log("this.geolocationService.objUser", this.geolocationService.objUserLocation);

    if (this.geolocationService.objUserLocation == undefined) {
      console.log("geolocationService.objUserLocation undefined");
      this.geolocationService.getGeoLocation();

      // below code to subscribe the updated location
      this.geolocationService._Location.subscribe(location => {
        console.log(location);
        this.objUserPosition = location;
      })
    } else {
      console.log("set geolocationService.objUserLocation")
      this.objUserPosition = this.geolocationService.objUserLocation;
    }
    //this.objUserPosition = { lat: 6.2426977, lng: -75.5494904 };
  }


  get getTextsIUGeochallengesForm() {
    //console.log(this.languageService.textsIU.page_home);
    return this.languageService.textsIU.page_geochallenges_form;
  }

  public viewMore() {
    this.router.navigate(['app/geochallenges', 'list']);
  }

  cancelForm({ detail: { id, type } }){
    this.router.navigate(['app/geochallenges', 'detail',type,id]);
  }

  public viewInMap(){
    if(this.challenge) {
      const browser = this.iab.create('https://www.google.com/maps/search/?api=1&query=' + this.challenge['geopoint']['lat'] +',' +  this.challenge['geopoint']['lng']);
     //browser.close();
    }
  }

  navigateLocation(){
    let options: LaunchNavigatorOptions = {
      start:[this.objUserPosition.lat,this.objUserPosition.lng],
      app: this.launchNavigator.APP.GOOGLE_MAPS
    };
    this.launchNavigator.navigate([this.challenge['geopoint']['lat'],this.challenge['geopoint']['lng']], options)
    .then(success =>{
      console.log("launchNavigator sucess",success);
    },error=>{
      console.log("launchNavigator error", error);
    })
  }

  getCredentialsChallengesPrefix = async () => {
    // return await this.contentService.getSignature();
  };

}
